import Component from './Dashboard.component';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    return {
        allowedReports: fromState.Dashboard.getAllowedReports(state),
    };
};

export default connect(mapStateToProps)(Component);
